import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { TIssueCategory, TGenericIssueDTO } from '@monorepo/types';

@Component({
  selector: 'monorepo-reject-v2-multi-select',
  templateUrl: './reject-v2-multi-select.component.html',
  styleUrls: ['./reject-v2-multi-select.component.scss'],
})
export class RejectV2MultiSelectComponent implements OnInit, OnChanges {
  @Input() lists: TGenericIssueDTO[] = [];
  @Input() preSelectedList: TGenericIssueDTO[] = [];
  @Output() selectedList = new EventEmitter<TRejectV2MultiSelectComponent[number]['data'][]>();

  multiSelectList: TRejectV2MultiSelectComponent = [];
  filterString: string = '';
  filteredList: TRejectV2MultiSelectComponent = [];
  categoriesToShow = new Set<TIssueCategory>();
  category: TIssueCategory | undefined;

  trackByFn(index: number, item: TRejectV2MultiSelectComponent[number]) {
    return item.data.issueId;
  }

  ngOnInit(): void {
    this.init();
  }

  ngOnChanges(): void {
    this.init();
  }

  init() {
    this.multiSelectList = this.createMultiSelectList();
    this.filterDefects();
    this.getCategoriesToShow();
  }

  getCategoriesToShow() {
    this.filteredList.forEach((issue) => {
      this.categoriesToShow.add(issue.data.category);
    });
  }

  constructor() {}

  onSelect(id: string) {
    this.multiSelectList = this.multiSelectList.map((v) => {
      if (v.data.issueId === id) {
        return {
          ...v,
          selected: !v.selected,
        };
      }
      return v;
    });
    this.selectedList.emit(this.multiSelectList.filter((v) => v.selected).map((v) => v.data));
  }

  getPreSelectedIdSet(list: TGenericIssueDTO[]) {
    const preSelectedItemIds = new Set<string>();
    list.forEach((item) => {
      preSelectedItemIds.add(item.issueId);
    });
    return preSelectedItemIds;
  }

  createMultiSelectList() {
    const preSelectedItemIds = this.getPreSelectedIdSet(this.preSelectedList);
    return this.lists.map((item) => {
      return {
        selected: preSelectedItemIds.has(item.issueId),
        data: item,
      };
    });
  }

  filterDefects(): void {
    const newArray: TRejectV2MultiSelectComponent = [];
    this.multiSelectList.forEach((elem: TRejectV2MultiSelectComponent[number]) => {
      if (
        (this.category ? elem.data.category === this.category : true) &&
        elem.data.issueName.toLowerCase().includes(this.filterString.toLowerCase())
      ) {
        newArray.push(elem);
      }
    });
    this.filteredList = newArray;
  }

  filterListByCategory(category: TIssueCategory | undefined) {
    this.category = category;
    this.filterDefects();
  }
}

type TRejectV2MultiSelectComponent = ReturnType<RejectV2MultiSelectComponent['createMultiSelectList']>;
